import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/vercel/path0/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useCallback } from 'react';
import BigNumber from 'bignumber.js';
import { BestBuy, Signer } from '@tokenlon/sdk';
import { BestBuySubmitStatus } from "../../../state/dex/type";
import { updateBestBuySubmitStatus, updateBestBuyInputAmount } from "../../../state/dex/actions";
import { useBestBuyPair, useBestBuyInputAmount, useBestBuyUserConfig, useTokenlonConfig } from "../../../state/dex/hooks";
import { parseUnits } from 'ethers/lib/utils';
import { useAppDispatch } from "../../../state/hooks";
import { ApplicationModal, updateRefreshToken } from "../../../state/application/reducer";
import { useModalSwitch } from "../../../state/application/hooks";
import { initialState } from "../../../state/dex/reducer";
import { captureException } from '@sentry/nextjs';
import dayjs from 'dayjs';
import { useWeb3React } from '@web3-react/core';
import { useTranslation } from 'react-i18next';
export var useTradeSubmit = () => {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useWeb3React = useWeb3React(),
      account = _useWeb3React.account,
      provider = _useWeb3React.provider;

  var _useBestBuyPair = useBestBuyPair(),
      _useBestBuyPair2 = _slicedToArray(_useBestBuyPair, 2),
      inputToken = _useBestBuyPair2[0],
      outputToken = _useBestBuyPair2[1];

  var _useBestBuyInputAmoun = useBestBuyInputAmount(),
      inputAmount = _useBestBuyInputAmoun.inputAmount;

  var _useBestBuyUserConfig = useBestBuyUserConfig(),
      expiration = _useBestBuyUserConfig.expiration,
      rate = _useBestBuyUserConfig.rate;

  var _useTokenlonConfig = useTokenlonConfig(),
      addressBookV5 = _useTokenlonConfig.addressBookV5;

  var switchReview = useModalSwitch(ApplicationModal.BEST_BUY_ORDER_PREVIEW);
  var dispatch = useAppDispatch();
  return useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var signer, outputAmount, _expiration$split, _expiration$split2, value, unit, expiry, bestBuyRequest, signedBestBuyOrder, _error$response;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            signer = new Signer(provider, 'web');
            dispatch(updateBestBuySubmitStatus(BestBuySubmitStatus.SignOrderPending));
            _context.prev = 2;
            outputAmount = new BigNumber(inputAmount).div(rate).decimalPlaces(outputToken === null || outputToken === void 0 ? void 0 : outputToken.decimals).toString();
            _expiration$split = expiration.split('_'), _expiration$split2 = _slicedToArray(_expiration$split, 2), value = _expiration$split2[0], unit = _expiration$split2[1];
            expiry = dayjs().add(Number(value), unit).unix();
            bestBuyRequest = {
              user: account,
              dealer: addressBookV5 === null || addressBookV5 === void 0 ? void 0 : addressBookV5.BestBuyDealer,
              userToken: inputToken.address,
              dealerToken: outputToken.address,
              userTokenAmount: parseUnits(inputAmount, inputToken.decimals).toString(),
              minDealerTokenAmount: parseUnits(outputAmount, outputToken.decimals).toString(),
              expiry
            };
            _context.next = 9;
            return signer.signBestBuy(bestBuyRequest);

          case 9:
            signedBestBuyOrder = _context.sent;
            _context.next = 12;
            return BestBuy.createBestBuyOrder(signedBestBuyOrder);

          case 12:
            dispatch(updateRefreshToken(+new Date()));
            switchReview(false);
            dispatch(updateBestBuySubmitStatus(BestBuySubmitStatus.SignOrderSuccess));
            dispatch(updateBestBuyInputAmount({
              inputAmount: initialState.bestBuyInputAmount
            }));
            _context.next = 23;
            break;

          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](2);
            console.error(_context.t0);
            captureException(_context.t0);

            if (_context.t0 !== null && _context.t0 !== void 0 && _context.t0.isAxiosError && _context.t0 !== null && _context.t0 !== void 0 && (_error$response = _context.t0.response) !== null && _error$response !== void 0 && _error$response.data.code) {
              dispatch(updateBestBuySubmitStatus(BestBuySubmitStatus["SignOrderFailureCode".concat(_context.t0.response.data.code)]));
            } else {
              dispatch(updateBestBuySubmitStatus(BestBuySubmitStatus.SignOrderFailure));
            }

          case 23:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 18]]);
  })), [account, provider, inputToken, outputToken, inputAmount, rate]);
};